module.exports = __webpack_public_path__ + "img/failed_candidate.b7bf4cc8.svg";